export const SET_ALL_POST = "SET_ALL_POST";
export const ADD_NEW_POST = "ADD_NEW_POST";
